const LANG_KEY = 'lang_token';
const DEFAULT_LANG = 'es';

export default {

  setLang(lang) {
      localStorage.setItem(LANG_KEY, lang);
  },

  getLang() {
    let lang = localStorage.getItem(LANG_KEY);

    if (!lang)
      return DEFAULT_LANG;

    return localStorage.getItem(LANG_KEY);
  },
  getAcceptLanguageLang() {
    let lang = this.getLang();
    switch (lang) {
      case 'en':
        return 'en-US';
      case 'es':
        return 'es-ES';
      case 'pt':
        return 'pt-BR';
      default:
        return 'es-ES';
    }
  },
  clearLang() {
    localStorage.removeItem(LANG_KEY);
  }
};



// WEBPACK FOOTER //
// ./src/services/LangService.js